// extracted by mini-css-extract-plugin
export var centerText = "retryButton-module--centerText--befa4";
export var iconButton = "retryButton-module--iconButton--d5277";
export var msg = "retryButton-module--msg--bf853";
export var text = "retryButton-module--text--fce0b";